export default {
  specificFilter: false,
  basic: {
    valorGteq: "",
    valorLteq: "",
    tribunais: [],
    anosVencimento: [],
    natureza: "",
    tipoProcesso: "",
  },
  advanced: {
    ufs: [],
    unidades: [],
    assuntos: [],
    devedores: [],
    expedidoGteq: null,
    expedidoLteq: null,
    municipal: false,
    estadual: false,
    federal: false,
  },
  specific: {
    nrProcesso: "",
    nrPrecatorio: "",
    nomeAdvogado: "",
    oabAdvogado: "",
    nomeCredor: "",
    documento: "",
  },
};
